import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, Tabs, Tab } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import { addItem, fetchId, selectId, selectLoading } from "./visitSlice";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  formatDate,
  CallApi,
  formatCurrency,
  formatQuantity,
  formatDateTime,
  formatterVisit,
  formatterStatus,
  useForceUpdate,
  columnsOrderHidden,
  columnsReturnHidden,
  addNumber,
  formatTime,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useHistory, useParams } from "react-router";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { NavLink } from "react-router-dom";

import {
  GoogleMap,
  Marker,
  DirectionsRenderer,
  useLoadScript,
} from "@react-google-maps/api";
import { ImageViewer } from "../../utility/ImageViewer";
import { env } from "../../../env";
import { Sledding } from "@mui/icons-material";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { ViewMapsMarker } from "../../utility/ViewMapsMarker";
import {
  FaAngleDoubleDown,
  FaAngleDoubleUp,
  FaAngleDown,
  FaAngleUp,
} from "react-icons/fa";
const { SearchBar } = Search;

export const VisitEdit = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectId);
  const { id } = useParams();

  const forceUpdate = useForceUpdate();

  const [tableOrders, setTableOrders] = useState([]);
  const [tableReturn, setTableReturn] = useState([]);
  const [tableStock, setTableStock] = useState([]);
  const [imageVisit, setImageVisit] = useState([]);
  const [imageTransfer, setImageTransfer] = useState([]);
  const [tableCollectPayment, setTableCollectPayment] = useState([]);
  const [collectPayment, setCollectPayment] = useState(null);
  const [points, setPoints] = useState([]);
  const [show, setShow] = useState(false);
  const [order, setOrder] = useState(null);

  const [pointsVisit, setPointsVisit] = useState([]);
  const [showMapVisit, setShowMapVisit] = useState(false);

  useEffect(() => {
    async function fetchMyAPI() {
      const params = {
        visit_id: id,
      };
      if (id !== undefined) {
        await CallApi(params, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch, id]);

  useEffect(() => {
    if (dataId) {
      // Add number
      const detailCheckin = dataId.detail_checkin || {};

      setOrder(detailCheckin.visit_orders);
      setCollectPayment(detailCheckin.visit_collection_payments);

      setTableOrders(
        addNumber(detailCheckin.visit_orders?.visit_order_details)
      );
      setTableReturn(addNumber(detailCheckin.visit_returs));
      setTableCollectPayment(
        addNumber(detailCheckin.visit_collection_payments?.visit_payment_orders)
      );
      setTableStock(addNumber(detailCheckin.stock_count_visibility));

      const filterAttachments = (type) =>
        dataId.visit_attachments?.filter(
          (attachment) => attachment.file_type === type
        ) ?? [];

      setImageVisit(filterAttachments("VISIT"));
      setImageTransfer(filterAttachments("TRANSFER"));

      setPointsVisit([
        {
          id: "1",
          lat: dataId.latitude,
          lng: dataId.longitude,
          label: "Store",
          store: dataId.customer_store_name,
          address: dataId.customer_address,
          visit_date: formatDateTime(dataId.visit_actual_date),
        },
        {
          id: "2",
          lat: dataId.visit_latitude,
          lng: dataId.visit_longitude,
          label: "Visit",
          store: "",
          address: "",
          visit_date: formatDateTime(dataId.visit_actual_date),
        },
      ]);

      forceUpdate();
    }
  }, [dataId]);

  const actionFormatter = (e, row) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="journeys-edit-tooltip">Detail</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
            onClick={() => {
              handleShow();
              setOrder(row);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-secondary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsStock = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },
    {
      text: "product code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "product name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "stock",
      dataField: "stock",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "visibility",
      dataField: "vis",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatQuantity,
      align: "right",
    },
  ];

  const columnsOrder = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      footer: "",
    },
    {
      text: "product code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      footer: "",
    },
    {
      text: "product name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      footer: "",
    },
    {
      text: "unit price",
      dataField: "unit_price",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
      footer: "",
    },
    {
      text: "price discount",
      dataField: "discount_amount",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
      footer: "",
    },
    {
      text: "Final price",
      dataField: "price_after_discount",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
      footer: "",
    },
    {
      text: "qty",
      dataField: "quantity",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatQuantity,
      align: "right",
      footer: "",
    },
    {
      text: "uom",
      dataField: "uom_description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      footer: "",
    },
    {
      text: "total price",
      dataField: "total_price",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
      formatter: formatCurrency,
      align: "right",
      footer: (columnData) => {
        const parsedData = columnData.map((item) => parseFloat(item));
        const total = parsedData.reduce((acc, item) => acc + item, 0);
        if (total === 0) {
          return null; // Menyembunyikan footer jika total harga adalah 0
        }
        return formatCurrency(total);
      },
      footerAlign: (column, colIndex) => "right",
    },
  ];

  const columnsReturn = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      footer: "",
    },
    {
      text: "product code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      footer: "",
    },
    {
      text: "product name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      footer: "",
    },
    {
      text: "retur date",
      dataField: "retur_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatDate,
      footer: "",
    },
    {
      text: "remark",
      dataField: "remarks_return",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      footer: "",
    },

    {
      text: "ok",
      dataField: "ok_quantity",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100" },
      formatter: formatQuantity,
      align: "right",
      footer: "",
    },
    {
      text: "damage",
      dataField: "dmg_quantity",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100" },
      formatter: formatQuantity,
      align: "right",
      footer: "",
    },
    {
      text: "expired",
      dataField: "exp_quantity",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100" },
      formatter: formatQuantity,
      align: "right",
      footer: "",
    },

    {
      text: "total quantity",
      dataField: "total_quantity",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatQuantity,
      align: "right",
      footer: "",
    },
    {
      text: "unit price",
      dataField: "unit_price",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
      footer: "",
    },
    {
      text: "total price",
      dataField: "total_price",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
      footer: (columnData) => {
        const parsedData = columnData.map((item) => parseFloat(item));
        const total = parsedData.reduce((acc, item) => acc + item, 0);
        if (total === 0) {
          return null; // Menyembunyikan footer jika total harga adalah 0
        }
        return formatCurrency(total);
      },
      footerAlign: (column, colIndex) => "right",
    },
  ];

  const columnsPayment = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "order date",
      dataField: "order_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
          >
            <NavLink
              className="menu-link"
              to={`/transaction/order/detail/${row.visit_order_id}`}
            >
              {formatDate(cell)}
            </NavLink>
          </span>
        );
      },
    },
    {
      text: "order due date",
      dataField: "order_due_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatDate,
    },
    {
      text: "status",
      dataField: "status",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
    },

    {
      text: "payment amount",
      dataField: "payment_amount",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatQuantity,
      align: "right",
    },
  ];

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const [key, setKey] = useState("Month");

  const columnsDetail = [
    {
      text: " bonus product",
      dataField: "product_code",
      style: { maxWidth: "120px" },
      formatter: (cell, row) => (
        <div>
          <span>
            <b>{row.product_code}</b>
          </span>
          <br />
          <span>{row.product_name}</span>
        </div>
      ),
    },
    {
      text: "Uom",
      dataField: "uom_description",
      style: { maxWidth: "60px" },
    },
    {
      text: "bonus qty",
      dataField: "bonus_quantity",
      style: { maxWidth: "120px" },
      formatter: formatQuantity,
      align: "right",
    },
  ];

  const expandRow = {
    expandByColumnOnly: true,
    showExpandColumn: true,
    renderer: (row) => (
      <BootstrapTable
        keyField="product_code"
        data={
          row.bonus_items_decoded.length === 0 ? [] : row.bonus_items_decoded
        }
        columns={columnsDetail}
      />
    ),
    expandColumnRenderer: ({ expanded, rowKey, expandable }) =>
      expandable ? expanded ? <FaAngleUp /> : <FaAngleDown /> : null,

    expandHeaderColumnRenderer: ({ isAnyExpands }) =>
      isAnyExpands ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />,
    align: "center",
    nonExpandable: tableOrders
      .filter((row) => row.bonus_items_decoded.length === 0)
      .map((row) => row.no), // Replace 'id' with the actual key field of your row
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            Detail Visit{" "}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="invoice-container">
            <div className="invoice-content">
              <div className="invoice-col">
                <h2>Visit Details</h2>
                <div className="invoice-row">
                  <span>Visit Status:</span>
                  <span>{formatterVisit(dataId?.visit_status_name)}</span>
                </div>
                <div className="invoice-row">
                  <span>Visit Distance:</span>
                  <span>
                    <span
                      className="svg-icon svg-icon-md svg-icon-secondary"
                      onClick={(e) => setShowMapVisit(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Map/Marker1.svg")}
                      />
                    </span>
                    {formatterStatus(dataId?.status_distance)}
                  </span>
                </div>
                <div className="invoice-row">
                  <span>Visit Category:</span>
                  <span>{dataId?.visit_category_name}</span>
                </div>

                <div className="invoice-row">
                  <span> Visit Plan Date:</span>
                  <span>{formatDate(dataId?.visit_plan_date)}</span>
                </div>
                <div className="invoice-row">
                  <span>Visit/Pending Time:</span>
                  <span>
                    {formatTime(dataId?.check_in_at)}
                    {dataId?.visit_actual_date &&
                      ` - ${formatTime(dataId.visit_actual_date)}`}
                  </span>
                </div>

                {dataId?.check_in_at && dataId?.visit_actual_date && (
                  <div className="invoice-row">
                    <span>Visit Duration:</span>
                    <span>
                      {Math.round(
                        (new Date(dataId.visit_actual_date) -
                          new Date(dataId.check_in_at)) /
                          60000
                      )}{" "}
                      minutes
                    </span>
                  </div>
                )}
                <div className="invoice-row">
                  <span>Customer Code:</span>
                  <span>{dataId?.customer_code}</span>
                </div>
                <div className="invoice-row">
                  <span>Customer Store Name:</span>
                  <span>
                    {" "}
                    <NavLink
                      className="menu-link"
                      to={`/master/customer/edit/${dataId?.customer_id}`}
                    >
                      {dataId?.customer_store_name}
                    </NavLink>
                  </span>
                </div>
                <div className="invoice-row">
                  <span>Customer Address:</span>
                  <span className="half-width">{dataId?.customer_address}</span>
                </div>
                <div className="invoice-row">
                  <span>Customer Contact Name:</span>
                  <span>{dataId?.customer_contact_name}</span>
                </div>
                <div className="invoice-row">
                  <span>Customer Phone Number:</span>
                  <span>{dataId?.customer_phone_number}</span>
                </div>
                <div className="invoice-row">
                  <span>Payment Type:</span>
                  <span>{dataId?.customer_payment_type}</span>
                </div>

                {imageVisit.length > 0 && (
                  <div className="invoice-row">
                    <strong>Visit Image:</strong>

                    <div className="row mt-2">
                      {imageVisit.map((item, index) => (
                        <div className="col-auto small-image" key={index}>
                          <ImageViewer url={item.file_path} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <div className="invoice-col">
                <h2>Order Summary</h2>
                <div className="invoice-row">
                  <span>Status:</span>
                  <span>
                    {order?.status !== undefined
                      ? formatterStatus(order?.status)
                      : formatterStatus("No Order")}
                  </span>
                </div>
                <div className="invoice-row">
                  <span>Order Date:</span>
                  <span>{formatDate(order?.order_date)}</span>
                </div>
                <div className="invoice-row">
                  <span>Order Due Date:</span>
                  <span>{formatDate(order?.order_due_date)}</span>
                </div>
                <div className="invoice-row">
                  <span>Order Amount:</span>
                  <span>{formatCurrency(order?.order_total)}</span>
                </div>
                <div className="invoice-row">
                  <span>Discount Amount:</span>
                  <span>{formatCurrency(order?.discount_amount)}</span>
                </div>
                <div className="invoice-row">
                  <span>Return Amount:</span>
                  <span style={{ color: "red" }}>
                    {dataId?.detail_checkin?.visit_orders === null
                      ? formatCurrency(dataId?.total_returs)
                      : formatCurrency(order?.order_retur)}
                  </span>
                </div>

                <div className="invoice-row">
                  <span>Final Amount:</span>
                  <span
                    style={{ color: order?.order_final < 0 ? "red" : "black" }}
                  >
                    {formatCurrency(order?.order_final)}
                  </span>
                </div>
                <div className="invoice-row">
                  <span>Sum Paid:</span>
                  <span style={{ color: "green" }}>
                    {formatCurrency(order?.order_sum_paid)}
                  </span>
                </div>
                <div className="invoice-row">
                  <span>Remaining Amount:</span>
                  <span
                    style={{
                      color: order?.order_remain < 0 ? "red" : "black",
                    }}
                  >
                    {formatCurrency(order?.order_remain)}
                  </span>
                </div>
                <h2 className="mt-3">Payment Summary</h2>
                <div className="invoice-row">
                  <span>Payment Cash:</span>
                  <span>{formatCurrency(dataId?.payment_cash)}</span>
                </div>
                <div className="invoice-row">
                  <span>Payment Transfer:</span>
                  <span>{formatCurrency(dataId?.payment_transfer)}</span>
                </div>
                <div className="invoice-row">
                  <span>Payment Total:</span>
                  <span style={{ color: "green" }}>
                    {formatCurrency(dataId?.payment_total)}
                  </span>
                </div>

                {imageTransfer.length > 0 && (
                  <div className="invoice-row">
                    <span>Proof of Transfer :</span>

                    {imageTransfer.map((item, index) => (
                      <div className="small-image">
                        <ImageViewer url={item.file_path} />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <Tabs
            defaultActiveKey="Stock Count Visibility"
            id="uncontrolled-tab-example"
            className="mb-5"
          >
            <Tab
              eventKey="Stock Count Visibility"
              title="Stock Count Visibility"
            >
              <div
                className="card-body pt-0"
                style={{
                  // height: "650px",
                  overflowY: "scroll",
                }}
              >
                <ToolkitProvider
                  keyField="no"
                  data={tableStock}
                  columns={columnsStock}
                  search
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container">
                        <BootstrapTable
                          striped
                          noDataIndication="Data Not Found"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </Tab>
            <Tab eventKey="Collect Payments" title="Collect Payments">
              <div
                className="card-body pt-0"
                style={{
                  // height: "650px",
                  overflowY: "scroll",
                }}
              >
                <ToolkitProvider
                  keyField="no"
                  data={tableCollectPayment}
                  columns={columnsPayment}
                  search
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container">
                        <BootstrapTable
                          striped
                          noDataIndication="Data Not Found"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </Tab>
            <Tab eventKey="Return Product" title="Return Product">
              <div
                className="card-body pt-0"
                style={{
                  // height: "650px",
                  overflowY: "scroll",
                }}
              >
                <ToolkitProvider
                  keyField="no"
                  data={tableReturn}
                  columns={
                    tableReturn.length > 0 ? columnsReturn : columnsReturnHidden
                  }
                  search
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container">
                        <BootstrapTable
                          striped
                          noDataIndication="Data Not Found"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </Tab>
            <Tab eventKey="Orders" title="Orders">
              <div
                className="card-body pt-0"
                style={{
                  // height: "650px",
                  overflowY: "scroll",
                }}
              >
                <ToolkitProvider
                  keyField="no"
                  data={tableOrders}
                  columns={
                    tableOrders.length > 0 ? columnsOrder : columnsOrderHidden
                  }
                  search
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container">
                        <BootstrapTable
                          striped
                          noDataIndication="Data Not Found"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                          expandRow={expandRow}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </Tab>
            {/* <Tab eventKey="Payment" title="Payment">
                <Form>
                  <Form.Group as={Row}>
                    <Col sm={6}>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Payment Date</b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            disabled
                            value={
                              dataId?.detail_checkin?.visit_order_payments
                                ?.payment_date
                            }
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>No Ref</b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            className="text-right"
                            disabled
                            value={
                              dataId?.detail_checkin?.visit_order_payments
                                ?.payment_no_ref
                            }
                          />
                        </Col>
                      </Form.Group>
                    </Col>

                    <Col sm={6}>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Payment Cash</b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            className="text-right"
                            disabled
                            value={formatCurrency(
                              dataId?.detail_checkin?.visit_order_payments
                                ?.payment_cash
                            )}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Payment Transfer</b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            className="text-right"
                            disabled
                            value={formatCurrency(
                              dataId?.detail_checkin?.visit_order_payments
                                ?.payment_transfer
                            )}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Payment Total</b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            className="text-right"
                            disabled
                            value={formatCurrency(
                              dataId?.detail_checkin?.visit_order_payments
                                ?.payment_total
                            )}
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Form.Group>
                </Form>
              </Tab> */}
          </Tabs>
        </CardBody>
      </Card>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Details Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Order Date</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      value={formatDate(order?.order_date)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Order Total</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatCurrency(order?.order_total)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Order Sum Paid</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatCurrency(order?.order_sum_paid)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Order Remain</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatCurrency(order?.order_remain)}
                    />
                  </Col>
                </Form.Group>
              </Col>

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Order Retur</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatCurrency(order?.order_retur)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Order Final</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      className="text-right"
                      value={formatCurrency(order?.order_final)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Total Retur</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      className="text-right"
                      value={formatCurrency(order?.total_retur)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Total Final</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      className="text-right"
                      value={formatCurrency(order?.total_final)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <ViewMapsMarker
        points={pointsVisit}
        setPoints={setPointsVisit}
        show={showMapVisit}
        setShow={setShowMapVisit}
      />
    </>
  );
};
